import React from 'react';
import ReactModal from 'react-modal';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import Button from 'yola-editor/src/js/components/button';

function GenericDialog({
  captions: { mainAction, secondaryAction },
  children,
  mainActionLink = null,
  mainActionDisabled = false,
  onMainAction = null,
  onSecondaryAction = Function.prototype,
  onClose,
  className = '',
}) {
  const isFooterShown = onMainAction || mainActionLink;
  const onMainActionHandler = onMainAction || Function.prototype;

  return (
    <ReactModal
      isOpen
      onRequestClose={onClose}
      className={classNames('dialog dialog--generic', className)}
      overlayClassName="dialog-overlay"
    >
      {secondaryAction && (
        <div className="dialog-header">
          <Button type="link" size="small" onClick={onSecondaryAction}>
            {secondaryAction}
          </Button>
        </div>
      )}
      <div className="dialog-body">{children}</div>
      {isFooterShown && (
        <div className="dialog-footer">
          <Button
            type="secondary"
            size="large"
            target="blank"
            href={mainActionLink}
            onClick={onMainActionHandler}
            disabled={mainActionDisabled}
          >
            {mainAction}
          </Button>
        </div>
      )}
    </ReactModal>
  );
}

GenericDialog.propTypes = {
  captions: PropTypes.shape({
    mainAction: PropTypes.string,
    secondaryAction: PropTypes.string,
  }).isRequired,
  children: PropTypes.node.isRequired,
  mainActionDisabled: PropTypes.bool,
  mainActionLink: PropTypes.string,
  onMainAction: PropTypes.func,
  onSecondaryAction: PropTypes.func,
  onClose: PropTypes.func.isRequired,
  className: PropTypes.string,
};

export default GenericDialog;
